<script setup>
import CourseUpcomingItem from './CourseUpcomingItem.vue';

defineProps({
  date: {
    type: String,
    required: true,
  },
  courses: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <tr class="courses-section-date">
    <td colspan="3">
      {{ date }}
    </td>
  </tr>

  <CourseUpcomingItem
    v-for="course in courses"
    :key="course.id || course.sourceEventId"
    :course="course"
  />
</template>

<style scoped></style>
